import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-notification-modal-settings',
  standalone: true,
  imports: [CommonModule, FormsModule, MatCheckboxModule, MatIconModule, MatButtonModule],
  templateUrl: './notification-modal-settings.component.html',
  styleUrls: ['./notification-modal-settings.component.scss']
})
export class NotificationModalSettingsComponent {
  settingsState = {
    allActions: { notification: false, email: false },
    atMention: { notification: false, email: false },
    assigneeChanges: { notification: false, email: false },
    statusChange: { notification: false, email: false }
  };
  
  masterNotificationState = { checked: false, indeterminate: false };
  masterEmailState = { checked: false, indeterminate: false };

  updateMasterCheckboxes(): void {
    const notificationValues = [
      this.settingsState.atMention.notification,
      this.settingsState.assigneeChanges.notification,
      this.settingsState.statusChange.notification
    ];
    const emailValues = [
      this.settingsState.atMention.email,
      this.settingsState.assigneeChanges.email,
      this.settingsState.statusChange.email
    ];
    
    const allNotificationsChecked = notificationValues.every(v => v === true);
    const someNotificationsChecked = notificationValues.some(v => v === true);
    this.masterNotificationState = {
      checked: allNotificationsChecked,
      indeterminate: !allNotificationsChecked && someNotificationsChecked
    };
    
    const allEmailsChecked = emailValues.every(v => v === true);
    const someEmailsChecked = emailValues.some(v => v === true);
    this.masterEmailState = {
      checked: allEmailsChecked,
      indeterminate: !allEmailsChecked && someEmailsChecked
    };
    
    this.settingsState.allActions.notification = this.masterNotificationState.checked;
    this.settingsState.allActions.email = this.masterEmailState.checked;
  }
  
  onMasterNotificationChange(checked: boolean): void {
    this.settingsState.atMention.notification = checked;
    this.settingsState.assigneeChanges.notification = checked;
    this.settingsState.statusChange.notification = checked;
    this.updateMasterCheckboxes();
  }
  
  onMasterEmailChange(checked: boolean): void {
    this.settingsState.atMention.email = checked;
    this.settingsState.assigneeChanges.email = checked;
    this.settingsState.statusChange.email = checked;
    this.updateMasterCheckboxes();
  }
  
  onSettingChange(): void {
    this.updateMasterCheckboxes();
  }
  
  saveSettings(): void {
    console.log('Saving settings:', this.settingsState);
  }
}